import { DatePipe } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import {
  FiltersConfig,
  PaginatorFetcher,
  PaginatorFilters,
  TableComponent,
  TableConfig,
  TableModule,
  LinkModule,
  IconModule,
  EmptyStateModule
} from '@michelin/theme';
import { Subscription } from 'rxjs';
import { ImportFileService } from '../application/import-file/import-file.service';
import { ApplicationsService } from '../applications/applications.service';
import { Audits } from '../interfaces/audits';
import { PAGINATOR_SIZE_OPTIONS } from '../util/paginator-utils';
import { AuditsService } from './audits.service';

@Component({
  selector: 'mic-app-audits',
  templateUrl: './audits.component.html',
  styleUrls: ['./audits.component.scss'],
  imports: [TableModule, LinkModule, IconModule, EmptyStateModule]
})
export class AudtisComponent {
  private readonly fileService = inject(ImportFileService);
  private readonly applicationsService = inject(ApplicationsService);
  private readonly auditsService = inject(AuditsService);
  private readonly route = inject(ActivatedRoute);
  private readonly datePipe = inject(DatePipe);

  subscriptionApp: Subscription;
  applicationName = '';

  @ViewChild('paginatedTable') tableRef: TableComponent<Audits>;

  @ViewChild('paginatedTable') tableAudit: TableComponent<Audits>;

  // Material table configuration for the Audits
  auditsDataSource = new MatTableDataSource();
  auditsTableConfig: TableConfig<Audits> = {
    paginator: {
      pageSize: 5,
      pageSizeOptions: PAGINATOR_SIZE_OPTIONS,
      position: 'bottom',
      loaderColor: 'accent'
    },
    sort: {
      default: 'auditEventDate:desc'
    },
    columns: {
      principal: { cell: (elm: Audits) => elm.principal, header: 'Principal', sortable: true },
      auditEventType: { cell: (elm: Audits) => elm.auditEventType, header: 'Audit Event Type', sortable: true },
      auditEventDate: {
        cell: (elm: Audits) => this.datePipe.transform(elm.auditEventDate, 'dd/MMM/yyyy HH:mm'),
        header: 'Audit Event Date',
        sortable: true
      },
      data: { cell: 'Data', header: 'Data' }
    }
  };

  filtersConfig: FiltersConfig = {
    columns: {
      is_active: {
        fetcher: (filters: PaginatorFilters) => this.getData(filters)
      }
    }
  };

  fetcher: PaginatorFetcher<Audits> = (filters: PaginatorFilters) => {
    return this.getData(filters);
  };

  getData(filters: PaginatorFilters) {
    filters.extraFilters.applicationId = this.applicationsService.myObject.id;
    return this.auditsService.listAudits(
      filters.extraFilters,
      new PaginatorFilters({
        limit: filters.limit,
        sort: filters.sort,
        page: filters.page
      })
    );
  }

  state = TableConfig.getState(this.auditsTableConfig, this.route);

  fileLink(item: any) {
    this.fileService.downloadAudtiFile(item.id).subscribe((response) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.body]));
      link.download = item.data;
      link.click();
      window.URL.revokeObjectURL(link.href);
    });
  }
}
